export default {"src":"/_next/static/media/envirocropsWhite.88de0fb9.svg","height":26,"width":159,"blurWidth":0,"blurHeight":0};